namespace Gordic.Vyp.Lists
{
    const { gcontent } = Decorators

    @gcontent
    export class DataMatrixCteckaDlg extends GContentBase<Wfl.AC.WflBaseAC>
    {
        // filtr seznamu
        model: Wfl.Interface.GDataMatrixDto;
        validators: any;

        onContentReady()
        {
            this.CreateForm();
        }

        CreateForm()
        {
            const form = new Gordic.Forms.Form({ name: "FormSPISPI", layoutDescriptor: "L1M1S1" });

            form.addSection();
            const that = this;
            form.addRow("jres:23900107").addField("gstringbox", { name: Wfl.Interface.GDataMatrixDtoNames.Id, disabled: false, change: function (event, input) { if (input?.value) that.ZpracujData() } })
            form.addSection();
            form.addRow("jres:23900106") //RC 23900106 : Adresát
            .addField("gstringbox", { name: Wfl.Interface.GDataMatrixDtoNames.InfoAdresat, disabled: true })
            form.addRow("jres:23900107") //RC 23900107 : Identifikace zásilky
            .addField("gstringbox", { name: Wfl.Interface.GDataMatrixDtoNames.id_dorucenky,  disabled: true });

            form.addRow("jres:23900015").addField("gnumberbox", "w-3", { name: Wfl.Interface.GDataMatrixDtoNames.poplatek, decimals: 4, minValue: 0, maxValue: 99.9999, disabled: true });
            form.addRow("jres:23900016").addField("gnumberbox", "w-3", { name: Wfl.Interface.GDataMatrixDtoNames.vaha, decimals: 4, minValue: 0, maxValue: 99.9999, disabled: true });                 //RC 23900016 : Váha
            if (this.model.CistIPodaciCislo) form.addRow("jres:23900044").addField("gstringbox", "w-3", { name: Wfl.Interface.GDataMatrixDtoNames.pod_cislo, disabled: true }); //RC 23900044 : Podací číslo

            form.addPrefab(
                Gordic.Gin.Prefabs.GSuFunRef(
                    {
                        name: "predavajici",
                        model: "model.akt_ixs_fun=value.ixs_fun",
                        disabled: true    
                    },
                    {
                        label: "jres:23900197", //RC 23900197 : Vlastník
                    },
                    {
                        modPredani: false
                    }));

            this.defaultForm = $("<div>").appendTo(this.element).gform("createFrom", form);
            this.findFields().gfield("model", "apply", this.model).gfield("model", "validators", this.validators);

            // 21.07.2020 - TFeik
            // Odstranění zpomalovače.
            if (this.model.Warning)
            {
                Wfl.AC.WflBaseAC.ShowFlashWarning(this, this.model.Warning);   
                this.model.Warning = "";
            }

            this.SetField();
        }

        SetField()
        {
            var l_idPole = this.findFields("Id");
            if (l_idPole)
            {
                let l_label = "";
                switch (this.model.KrokCislo) {
                    case 1:
                        l_label = "jres:23900126"; //RC 23900126 : Zadejte identifikaci zásilky
                        break;
                    case 2:
                        l_label = "jres:23900114"; //RC 23900114 : Zadejte data-matrix kód
                        break;
                    case 3:
                        l_label = "jres:23900125"; //RC 23900044 : Podací číslo
                        break;
                    default:
                }
                l_idPole.gformrow("setLabel", l_label);
                l_idPole.gfield("focus");
            }
        }

        SetInfo()
        {
            Wfl.AC.WflBaseAC.ShowFlashByContentInfo(this);
            this.SetField();
        }

        ZpracujData()
        {
            debugger;
            this.findFields().gfield("model", "collect", this.model);
            if (this.model.Id)
            {
                if (this.model.PracovatNadSeznamem) {

                    switch (this.model.KrokCislo) {
                        case 1:
                            this.ZpracujDataZasilky();
                            break;
                        case 2:
                            this.ZpracujDataMatrix();
                            break;
                        case 3:
                            this.ZpracujPodaciCislo();
                            break;
                    }
                }
                else
                {
                    //TODO
                }
            }
        }

        ZpracujDataZasilky()
        {
            debugger;
            this.findFields().gfield("model", "collect", this.model);
            if (this.model.Id) this.model.id_dorucenky = this.model.Id!.trim()
            this.close(this.model);
        }

        OKClick()
        {
            this.ZpracujData();
        }

        ZpracujDataMatrix()
        {
            if (this.model.Id)
            {
                if (this.model.Id.trim().length < 30)
                {
                    Wfl.AC.WflBaseAC.ShowFlashWarning(this, "jres:23900115");   
                    this.SetField();
                }
                else
                {
                    Wfl.AC.WflBaseAC.HideFlashByContent(this);
                    const that = this;
                    this.call<Wfl.Interface.GDataMatrixDto>("ZpracujDataMatrix", { "model": this.model })
                        .done(function (model) {
                            if (model) {
                                that.model = model;
                                if (that.model.CistIPodaciCislo && that.model.DoporucenaZasilka)
                                {
                                    that.model.KrokCislo = 3;
                                    //that.Info = "jres:23900125"; //RC 23900125 : Zadejte podací číslo
                                    //that.ResultType = Gin.Interface.TypVysledkuOperace.Neurceno;
                                    that.model.Id = "";
                                    that.SetInfo();
                                    that.ApplyModel();
                                } else that.close(that.model);
                            }
                        })
                        .fail(function (reason) 
                        {
                            that.dialogs.error(reason.statusText);
                            that.SetField();
                        });
                }
            } 
        }

        ZpracujPodaciCislo()
        {
            this.model.pod_cislo = this.model.Id;
            this.close(this.model);
        }

        ApplyModel()
        {
            this.findFields().gfield("model", "apply", this.model);
            this.findFields("Id").gfield("focus");
        }

        ExitClick()
        {
            if (this.model)
            {
                this.close(null);   
            }       
        }
    }
}